<template>
  <div class="page-content">
    <!-- 页面标题区域 -->
    <div class="page-header d-flex d-flex-between d-flex-middle">
      <div class="page-title d-flex d-flex-middle">
        <span class="title-bar"></span>
        <span class="title-text">修改信息</span>
      </div>
      <a href="javascript:void(0)" class="back-link" @click="handlePrev">
        <em style="position: relative;top: -1px;">&lt;</em> 返回
      </a>
    </div>
    <div class="progressBox">
      <BmProgress :steps="steps" :current-step="3" />
    </div>
    <div class="contentBox">
      <SubmitRegistration 
        :need-query-student-info="true"
        @prev-step="handlePrev" 
        @next-step="handleNext" 
      />
    </div>
  </div>
</template>

<script>
import BmProgress from "@/components/bm/bmProgress.vue";
import SubmitRegistration from "@/components/bm/submitRegistration.vue";

export default {
  name: 'Step4SubmitRegistration',
  components: {
    BmProgress,
    SubmitRegistration
  },
  data() {
    return {
      steps: [
        { title: '选择就读地点' },
        { title: '选择报名专业' },
        { title: '注册资料' },
        { title: '提交报名' },
      ],
    }
  },
  mounted() {
    if(!localStorage.getItem('registerFormData')){
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    handlePrev() {
      this.$router.push({ name: 'mineBmRegisterInfo' })
    },
    handleNext(studentId) {
      this.$router.push({ name: 'bmRegister' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  padding: 0 30px;
  min-height: 500px;
}

.page-header {
  height: 80px;
  line-height: 80px;
  padding: 0;
  border-bottom: 1px solid #F2F2F2;
  margin-bottom: 40px;
  .page-title {
    padding: 0;
    .title-bar {
        display: inline-block;
        width: 6px;
        height: 18px;
        background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
        border-radius: 0 !important;
        margin-right: 10px;
    }

    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }
  .back-link{
    font-size: 14px;
    color: #767676;
    cursor: pointer;
  }
}
</style>
